/* global PRODUCTION VUE */
// import Vue from 'vue';
import { metrics } from './theme/scripts/ferg-metrics.js';
import slick from 'slick-carousel';
import 'slick-carousel/slick/slick.css';

console.log(`${PRODUCTION ? 'Production Environment' : 'Dev Environment'}`);

if (PRODUCTION) {
	// Production-specific settings go here.
	// console.log = () => {}; 
} else {
	metrics();
}

// Slick Code For Testimonials
document.addEventListener('DOMContentLoaded', function() {	
	jQuery(".testimonial-slider-inner").slick({
		dots: true,
		infinite: true,
		lazyLoad: true,
		pauseOnHover: true,
		arrows: true,
		animation: false,
		appendArrows: jQuery('.arrows'),
		prevArrow: '<i class="fas fa-chevron-left button-prev"></i>',
		nextArrow: '<i class="fas fa-chevron-right button-next"></i>',
		appendDots: jQuery('.dots'),
		autoplay: true,
  		autoplaySpeed: 5000,
		cssEase: 'none'
	});
});

// Slick Code For Locations
document.addEventListener('DOMContentLoaded', function() {	
	jQuery(".location-slider-inner").slick({
		infinite: true,
		lazyLoad: true,
		pauseOnHover: true,
		arrows: true,
		animation: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		appendArrows: jQuery('.slider-arrows'),
		prevArrow: '<i class="fas fa-chevron-left button-prev"></i>',
		nextArrow: '<i class="fas fa-chevron-right button-next"></i>',
		autoplay: true,
  		autoplaySpeed: 5000,
		  responsive: [
			{
				breakpoint: 1250,
				settings: {
				  slidesToShow: 3,
				},
			  },
			{
			  breakpoint: 850,
			  settings: {
				slidesToShow: 2,
			  },
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 1,
			  },
			}
		  ],
	});
});

document.addEventListener('DOMContentLoaded', function() {
	if (!PRODUCTION) console.log('DOMContentLoaded');
	
	// initVue();
	handleHamburgers();
	handleDropdowns();
	handleBacktoTop();
});

function handleHamburgers() {
	// Get all "navbar-burger" elements
	const navbarBurgers = document.querySelectorAll('.navbar-burger'); // Check if there are any navbar burgers
	
	if (navbarBurgers.length > 0) {
		// Add a click event on each of them
		navbarBurgers.forEach(function(el) {
			el.addEventListener('click', function() {
				// Get the target from the "data-target" attribute
				const target = el.dataset.target;
				const $target = document.getElementById(target); // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
				
				el.classList.toggle('is-active');
				$target.classList.toggle('is-active');
			});
		});
	}
}

function handleDropdowns() {
	const dropdowns = document.querySelectorAll('.navbar-dropdown');
	
	if (dropdowns.length > 0) {
		dropdowns.forEach(function(el) {
			const navbarItem = el.parentElement;
			const toggle = navbarItem.querySelector('.navbar-link');
			
			toggle.addEventListener('click', function() {
				navbarItem.classList.toggle('is-active');
				
				document.addEventListener('click', function _listener(e) {
					if (!navbarItem.contains(e.target)) {
						navbarItem.classList.toggle('is-active');
						document.removeEventListener('click', _listener);
					}
				});
			});
		});
	}
}

function handleBacktoTop(){
	const backToTop = document.getElementById('back-to-top');
	if(!backToTop) return;

	window.addEventListener('scroll', function(){
		if(window.scrollY > 700){
			backToTop.classList.add('is-visible');
		} else {
			backToTop.classList.remove('is-visible');
		}
	});

	backToTop.addEventListener('click', function(){
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});
	
}